import axios from "@/api/axiosInstance";

export function userSignup(payload) {
  return axios.post(`/api/v1/users/signup`, payload);
}

export function activateAccount(payload) {
  return axios.patch(
    `/api/v1/users/activateAccount/${payload.token}`,
    payload.values
  );
}

export function userLogin(payload) {
  return axios.post(`/api/v1/users/login`, payload);
}

export function forgotPassword(payload) {
  return axios.post(`/api/v1/users/forgotPassword`, payload);
}

export function resetPassword(payload) {
  return axios.patch(
    `/api/v1/users/resetPassword/${payload.token}`,
    payload.values
  );
}

export function updateMe(payload) {
  return axios.patch(`/api/v1/users/updateMe`, payload);
}

export function updatePassword(payload) {
  return axios.patch(`/api/v1/users/updateMyPassword`, payload);
}

export function logOut() {
  return axios.post(`/api/v1/users/logout`);
}
